export const COMMON_RADIUS = (value = "4px") => ({
  borderTopRightRadius: value,
  borderBottomRightRadius: value,
  borderTopLeftRadius: value,
  borderBottomLeftRadius: value,
  
})

export const COMMON_BORDER_COLOR = (value) => ({
  borderTopColor: value,
  borderLeftColor: value,
  borderRightColor: value,
  borderBottomColor: value,
})

export const COMMON_BORDER_WIDTH = (value = "1px") => ({
  borderTopWidth: value,
  borderRightWidth: value,
  borderLeftWidth: value,
  borderBottomWidth: value,
})

export const COMMON_BORDER_STYLE = (value = "solid") => ({
  borderTopStyle: value,
  borderRightStyle: value,
  borderLeftStyle: value,
  borderBottomStyle: value,
})

export const COMMON_CARD_STYLE = (theme) => ({
  backgroundColor: "white",
  borderRadius: "8px",
  border: `1px solid ${theme.RAColors?.gray200}`,
  height: 'initial',

  [theme.mediaQuery.small]: {
    padding: "16px",
  },
  [theme.mediaQuery.medium]: {
    padding: "24px",
  },
});

export const COMMON_PADDING = (value = '0px') => ({
  paddingTop: value,
  paddingRight: value,
  paddingBottom: value,
  paddingLeft: value,
})